import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {operationLogsList_template} from "../components/templates/operationLogsList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;

export class operations_logs extends vnModule_knockoutJS {

    protected logsList_template: operationLogsList_template;
    protected moduleXHRHdl: XMLHttpRequestHandler;

    //
    // implementation of base class [vnModule]
    protected getModuleName(): string {

        return "operation_logs";
    }

    //
    // implementation of base class [vnModule]
    buildContent(): Array<Element> {

        this.logsList_template = new operationLogsList_template("operationLogs", this.viewModel, this)

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Operation Logs List");

        return [this.logsList_template.build()];
    }

    public fillPage(): void {

        this.logsList_template.activateLoading();
        this.getFormData();
    }

    protected getFormData() {

        this.logsList_template.activateLoading();

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.logsList_template.getViewModelForRequest())]);
        let XHRHdl = new XMLHttpRequestHandler('/api/operation-logs/references', params, this);

        XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        XHRHdl.execute();
    }

    protected onGetFormDataReturn(req: any, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.logsList_template.setBrands(responseParsed.brands)
                obj.getItems();
            });
        }
    }


    public reorderLogs() {
        this.getItems();
    }

    public taskExecuterSelect() {
        this.getItems();
    }

    protected filterSimpleCancel() {

    }

    protected getItems() {

        this.logsList_template.activateLoading();

        if (this.moduleXHRHdl) {
            this.moduleXHRHdl.cancelAndReset();
        }

        let vm = this.logsList_template.getViewModelForRequest();

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(vm)]);

        this.moduleXHRHdl = new XMLHttpRequestHandler('/api/operation-logs/sections/get', params, this);
        this.moduleXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.moduleXHRHdl.onReadyStateFunction = this.onGetItemsReturn;
        this.moduleXHRHdl.execute();
    }

    protected onGetItemsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.logsList_template.deactivateLoading();
        }
    }

    protected updateList(responseParsed: any) {

        this.logsList_template.setSections(responseParsed.sections);
    }

    protected processSelectedAccountLogs(account) {

        localStorage.setItem("accountId", account);

        if (localStorage.getItem("accountId")) {

            this.logsList_template.getTemplateViewModel().accountId(localStorage.getItem("accountId"));
        }
        this.getItems();
    }

    // required from template [logsList_template]
    protected filterSimpleOnChange() {
        this.resetPageNumber();
        this.getItems();
    }

    // required from template [logsList_template]
    protected paginationOnPageClick() {
        this.getItems();
    }

    private resetPageNumber() {
        // go back to page 1 in the pagination
        this.logsList_template.pagination.getTemplateViewModel().pageNumber(1);
    }

    protected errorHandler(req, obj): void {

        setTimeout(function () {

            obj.getVnAppZone().showNotificationToModule(new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, req.message));

            obj.logsList_template.deactivateLoading();
            console.log("ERROR");
        }, 500);

    }

    // required from template [tasksList_template]
    protected executeAction() {
        this.executeActionOnAccounts();
    }


    protected executeActionOnAccounts() {

        this.logsList_template.activateLoading();

        let vm = this.logsList_template.getViewModelForRequest();
        vm["idBrand"] = this.getVnAppZone().app.params.idBrand;
        if (localStorage.getItem("accountId")) {
            vm["filters"]["accounts_selected"] = parseInt(localStorage.getItem("accountId"));
        }

        let params: Array<Array<string>> = [];
        params.push(["action", "get_execute_action"], ["data", ko.toJSON(vm)]);

        let XHRHdl = new XMLHttpRequestHandler('/api/brand/' + this.getVnAppZone().app.params.idBrand + 'logs/', params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = this.getRequestReturnFunction([{
            "code": 200,
            "function": this.onExecuteActionReturn
        }], this.errorHandler);
        XHRHdl.execute();
    }

    protected onExecuteActionReturn(req, obj) {

        if (req.data[0].cronCommand !== undefined) {
            setTimeout(function () {

                obj.getVnAppZone().addNotificationToModule(new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Actions applied with success."));
                obj.getVnAppZone().showNotificationToModule();

                obj.logsList_template.deactivateLoading();

                obj.refreshLogList();

            }, 500);
        } else {
            obj.getVnAppZone().addNotificationToModule(new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Actions applied with success."));
            obj.getVnAppZone().showNotificationToModule();
            obj.logsList_template.deactivateLoading();
        }


    }

    protected refreshLogList() {
        window.location.reload(true);
        this.processSelectedAccountLogsRefresh();
    }

    protected processSelectedAccountLogsRefresh() {

        if (localStorage.getItem("accountId")) {
            this.logsList_template.getTemplateViewModel().accountId(localStorage.getItem("accountId"));
        }

        this.getItems();
    }

    public getSectionLog() {
        this.logsList_template.activateLoading();

        if (this.moduleXHRHdl) {
            this.moduleXHRHdl.cancelAndReset();
        }

        let vm = this.logsList_template.getViewModelForRequest();

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(vm)]);

        this.moduleXHRHdl = new XMLHttpRequestHandler('/api/operation-logs/section/log/get', params, this);
        this.moduleXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.moduleXHRHdl.onReadyStateFunction = this.onGetSectionLogReturn;
        this.moduleXHRHdl.execute();
    }

    protected onGetSectionLogReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.logsList_template.setLogContent(responseParsed.data.replaceAll('\n', '<br>'));
            });
            obj.logsList_template.deactivateLoading();
        }
    }

    public getSectionLogs() {
        this.logsList_template.activateLoading();

        if (this.moduleXHRHdl) {
            this.moduleXHRHdl.cancelAndReset();
        }

        let vm = this.logsList_template.getViewModelForRequest();

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(vm)]);

        this.moduleXHRHdl = new XMLHttpRequestHandler('/api/operation-logs/section/logs/get', params, this);
        this.moduleXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.moduleXHRHdl.onReadyStateFunction = this.onGetSectionLogsReturn;
        this.moduleXHRHdl.execute();
    }

    protected onGetSectionLogsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.logsList_template.setLogs(responseParsed.logs);
            });
            obj.logsList_template.deactivateLoading();
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/operation_logs.ts